import React from 'react';

// Comps
import Paragraph from '@project-stories/elements/Paragraph/Paragraph';
import { Link } from '@arctheme-components/elements/Link/Link';
import Headings from '@src/stories/elements/Headings/Headings';

import helpers from 'frontend/js/helpers';

type Props = {
  settings: any;
  isPageHeading?: boolean;
};

export const SectionHeader = ({ settings, isPageHeading }: Props) => {
  const {
    header_margin_bottom,
    header_margin_bottom_mobile,
    tagline,
    tagline_accent_parts,
    tagline_accent_color,
    tagline_heading_type,
    tagline_margin_bottom_mobile,
    tagline_margin_bottom,
    heading,
    heading_accent_parts,
    heading_accent_color,
    heading_type,
    heading_margin_bottom_mobile,
    heading_margin_bottom,
    description,
    body_type,
    description_margin_bottom_mobile,
    description_margin_bottom,
    cta_label,
    cta_url,
    cta_style,
    header_max_width,
    header_max_width_mobile,
    header_alignment
  } = settings.section;

  if (!heading && !description && !cta_label && !cta_url && !tagline)
    return null;

  return (
    <div
      className={`flex flex-col ${header_alignment} mb-[${header_margin_bottom_mobile}px] lg:mb-[${header_margin_bottom}px]`}
    >
      {tagline && (
        <span
          className={`${tagline_heading_type} mb-[${tagline_margin_bottom_mobile}px] lg:mb-[${tagline_margin_bottom}px] max-w-[${header_max_width_mobile}px] lg:max-w-[${header_max_width}px]`}
          dangerouslySetInnerHTML={{
            __html: helpers.renderAccentText(
              tagline,
              tagline_accent_parts,
              tagline_accent_color
            )
          }}
        />
      )}

      {heading && (
        <Headings
          type={isPageHeading ? 'h1' : 'h2'}
          classes={`${heading_type} mb-[${heading_margin_bottom_mobile}px] lg:mb-[${heading_margin_bottom}px] max-w-[${header_max_width_mobile}px] lg:max-w-[${header_max_width}px]`}
          text={helpers.renderAccentText(
            heading,
            heading_accent_parts,
            heading_accent_color
          )}
        />
      )}

      {description && (
        <Paragraph
          text={description}
          type={body_type}
          classes={`mb-[${description_margin_bottom_mobile}px] lg:mb-[${description_margin_bottom}px] max-w-[${header_max_width_mobile}px] lg:max-w-[${header_max_width}px]`}
        />
      )}

      {cta_label && cta_url && (
        <Link
          link={cta_url}
          classes={cta_style}
        >
          {cta_label}
        </Link>
      )}
    </div>
  );
};
